import type { DropdownValuesResponse } from './schedule.types'

const MALFORMED_DROPDOWN_VALUES = 'Malformed dropdown values response'

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value)
}

function isNonNegativeInteger(value: unknown): value is number {
  return typeof value === 'number' && Number.isInteger(value) && value >= 0
}

/** Strict decoder for the schedule/dimension point-read envelope. */
export function parseDropdownValuesResponse(value: unknown): DropdownValuesResponse {
  if (!isRecord(value) || !isRecord(value.data)) throw new TypeError(MALFORMED_DROPDOWN_VALUES)
  const data = value.data
  if (
    !isNonNegativeInteger(data.workspace_id) ||
    !isNonNegativeInteger(data.schedule_id) ||
    typeof data.dimension !== 'string' ||
    !data.dimension ||
    !Array.isArray(data.values) ||
    !data.values.every((item) => typeof item === 'string') ||
    !isNonNegativeInteger(data.unique_count)
  ) {
    throw new TypeError(MALFORMED_DROPDOWN_VALUES)
  }
  return {
    data: {
      workspace_id: data.workspace_id,
      schedule_id: data.schedule_id,
      dimension: data.dimension,
      values: [...data.values],
      unique_count: data.unique_count,
    },
  }
}
